import {useEffect, useState} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { IJobsheet } from "../../../interfaces/jobsheets/IJobsheet";
import IProduct from "../../../interfaces/products/IProduct";
import { useDictionary } from "../../../reducers/useDictionary";
import { PageContainer } from "../../components/container";
import * as webHelpers from "../../../helpers/WebHelpers";
import SquareTokenizeForm from "../../components/square/tokenize";
import * as WebHelpers from "../../../helpers/WebHelpers";
import { Flex, Heading, Text } from "@chakra-ui/react";

export default function CapturePage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { jobNumber } = useParams();

    const [loading, setLoading] = useState<boolean>(false);
    const [isInProgress, setIsInProgress] = useState<boolean>(false);

    const [jobsheet, setJobsheet] = useState<IJobsheet | null>(null);

    const getJobsheet = async () => {
        return await webHelpers.getAsync<IJobsheet | null>(
            "/api/sales/work/jobsheet" + (jobNumber == null ? "" : "?job=" + jobNumber),
        );
    };

    const refresh = () => {
        getJobsheet().then(js => {
            setJobsheet(js);
            console.log(js);
            setLoading(false);
        }).catch(reason => {
            navigate("/customer/signout");
            setLoading(false);
        });
    }

    // useEffect(() => {
    //     if (jobNumber != null) {
    //         refresh();
    //     }
    // }, [ jobNumber ]);

    useEffect(() => {
        if (jobsheet === null && !loading) {
            setLoading(true);

            if (jobNumber != null) {
                refresh();
            }
            else {
                navigate("/customer/signout");
            }
        }
    }, []);

    const handleCompleted = async (token: string) => {
        await WebHelpers.postAsync("/api/verify/card/details", { job: jobNumber, token: token, appointment: jobsheet?.appointment });

        navigate("/customer/overview/" + jobNumber);
    }

    if (loading || jobsheet == null || jobNumber == null) {
        return (
            <PageContainer pageTitle="Capture" >
                <Flex>
                    <Text>Waiting for jobsheet to load...</Text>
                </Flex>
            </PageContainer>
        );
    }

    return (
        <PageContainer pageTitle="Capture">
            <Flex direction='column' w='full' mt={5}>
                <Heading size='lg' mb={4} textAlign='center' textColor='var(--Able-blue)'>Enter Card Details</Heading>
                <Text textAlign='center' fontSize='lg'>Before we complete booking your job in, we ask for your card details to secure your job.</Text>
                <Text textAlign='center' fontSize='lg'>You will NOT be charged until after the work has been completed, or if a deposit is needed.</Text>

                <SquareTokenizeForm callback={handleCompleted} billingContact={jobsheet.customer}/>
            </Flex>
        </PageContainer>
    );
}
//<SquareForm billingContact={jobsheet.contact} />